import SearchBoxRoot from "./searchbox";

const SearchBoxUI = SearchBoxRoot

export default SearchBoxUI
